"use strict";
import { __exports as r } from "./index.es350.js";
var u;
function s() {
  return u ? r : (u = 1, (function(n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), Object.defineProperty(n, "ensureLeadingSlash", {
      enumerable: !0,
      get: function() {
        return t;
      }
    });
    function t(e) {
      return e.startsWith("/") ? e : "/" + e;
    }
  })(r), r);
}
export {
  s as __require
};
//# sourceMappingURL=index.es348.js.map
